import React from 'react';
import '../styles/UeberUns.css';
import sushiImage from '../assets/images/uber.webp';
import { FaPhoneAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';


const HelloCharge = () => {
    const { t } = useTranslation();

    return (
        <section className="hello-wrapper">
            <div className="section-container hello-container">
                <div className="hello-image">
                    <img src={sushiImage} alt="Sushi" />
                </div>
                <div className="hello-content">
                    <span className="hello-badge">{t('hello.badge')}</span>
                    <h2 className="hello-title">
                        {t('hello.title1')} <br />
                        <span className="charge-line">

                            <div className="dividerUberUns">•••••</div>
                        </span>
                    </h2>

                    <h4 className="hello-subtilte">{t('hello.subtitle1')}</h4>
                    <h5 className="hello-subtilte">{t('hello.subtitle2')}</h5>

                    <p className="hello-description">
                        {t('hello.description')}
                    </p>

                    <div className="hello-contact">
                        <div className="hello-icon">
                            <FaPhoneAlt />
                        </div>
                        <div className="hello-phone-text">
                            <p className="hello-call-text">{t('hello.callText')}</p>
                            <p className="hello-phone-number">03081098009</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HelloCharge;
